/** One tier's worth of documents, in the order the API sent them. */

import type { PortalDocument } from '@insuredhq/contract';

import { DocumentRow } from './DocumentRow';

interface DocumentGroupProps {
  heading: string;
  note?: string;
  emptyMessage: string;
  documents: PortalDocument[];
  openingId: string | null;
  onOpen: (document: PortalDocument) => void;
}

export function DocumentGroup({
  heading,
  note,
  emptyMessage,
  documents,
  openingId,
  onOpen,
}: DocumentGroupProps) {
  return (
    <section className="group">
      <h2>{heading}</h2>
      {note === undefined ? null : <p className="lede">{note}</p>}
      {documents.length === 0 ? (
        <p className="empty">{emptyMessage}</p>
      ) : (
        <ul className="document-list">
          {documents.map((document) => (
            <DocumentRow
              key={document.id}
              document={document}
              opening={openingId === document.id}
              onOpen={onOpen}
            />
          ))}
        </ul>
      )}
    </section>
  );
}
